import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeResetPasswordPage from "@/pages/employee/EmployeeResetPasswordPage";

export const Route = createFileRoute("/employee_/reset-password")({
  head: () => pageHead("Employee Reset Password", "Reset your AKIVA employee password.", "/employee/reset-password", true),
  component: EmployeeResetPasswordPage,
});
